
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c8f128a4&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ListParticipantsCollapsed.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ListParticipantsCollapsed.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c8f128a4!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ListParticipantsCollapsed.vue"),
  /* scopeId */
  "data-v-c8f128a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/Participants/ListParticipantsCollapsed.vue
// module id = 1884
// module chunks = 61